/* eslint-disable */
// Generated by `pnpm run tasks generate-schema`

import { Thunder } from '../generated/content_role_admin'
import { fromThunder } from '../zeus/fromThunder'
export { Selector, type FragmentResult, useZeusVariables } from '../generated/content_role_admin'

export const content_role_adminZeus = fromThunder(Thunder, { url: `${process.env.BACKEND_URL}/content` })
